export default "__VITE_ASSET__Bs4Bm0zF__"